export default "__VITE_ASSET__DQQHXs9x__"